import { useEffect } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
import { NumericFormat } from "react-number-format";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Components
import LayoutModal from "../../../LayoutModal";
import Loading from "../../../Loading";
//Interface
import { Inputs } from "Interfaces/IAccessory";
import { ICreate } from "Interfaces/ICreate";

export default function Update({
  isOpenModal,
  setModalClose,
  refreshFrames,
  selectedUrlId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const {
    isLoading: isLoadingAttribute,
    startLoading: startLoadingAttribute,
    stopLoading: stopLoadingAttribute,
  } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`accessory/${selectedUrlId}`);
      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModal, selectedUrlId]);

  const toUpperCaseStrings = (obj: Record<string, any>) => {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        typeof value === 'string' ? value.toUpperCase() : value,
      ])
    );
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoadingAttribute();
    try {
      const { name, amount, price } = data;
      const payload = toUpperCaseStrings({ name, amount, price });

      console.log('payload: ', payload);

      const response = await apiRequest(`accessory/${selectedUrlId}`, 'PATCH', payload);
      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        setModalClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoadingAttribute();
    }
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoadingAttribute}
        title="Atualizar Acessório"
        subTitle="Atualize informações do acessório em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Acessório'}
      >

        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.FormInput>
              <S.Label>
                Nome do Acessório
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome"
                type="text"
                {...register("name", { required: true })}
              />
              {errors.name && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>Quantidade</S.Label>
                <S.Input
                  placeholder="Informe a quantidade"
                  type="number"
                  {...register("amount", { required: true })}
                />
                {errors.amount && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>Preço</S.Label>
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: 'Campo Obrigatório' }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue); // Atualiza o valor de compra
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.price && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
